const isDevMode = process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEV_MODE
export default isDevMode
